import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { useSubscription } from '@/context/SubscriptionContext'
import { Nav } from '@/components/layout'
import { LandingNav } from '@/components/landing'

export function CheckoutSuccessPage() {
  const { isAuthenticated } = useAuth()
  const { refreshUsage } = useSubscription()

  useEffect(() => {
    if (isAuthenticated) {
      refreshUsage()
    }
  }, [isAuthenticated, refreshUsage])

  return (
    <div className="min-h-screen bg-primary-bg">
      {isAuthenticated ? <Nav /> : <LandingNav />}
      <div className="max-w-lg mx-auto px-4 py-24 text-center">
        <h1 className="text-3xl font-medium mb-4">You're in.</h1>
        <p className="text-secondary-text mb-8">
          Your subscription is active. Time to start creating.
        </p>
        <Link to="/create" className="btn btn-primary">
          Go to Beacon
        </Link>
      </div>
    </div>
  )
}
